import { AlertTriangle, X } from 'lucide-react';
import { useLanguage } from '../../../features/language/useLanguage';

interface DashboardErrorToastProps {
  message: string;
  onClose: () => void;
}

/** Floating bottom-right toast for transient dashboard action errors. */
export function DashboardErrorToast({ message, onClose }: DashboardErrorToastProps) {
  const { t } = useLanguage();
  return (
    <div className="fixed bottom-6 right-6 z-50 animate-bounce">
      <div className="bg-gray-900 text-white pl-4 pr-2 py-3 rounded-2xl shadow-[0_20px_40px_rgba(0,0,0,0.2)] flex items-center gap-3">
        <div className="bg-red-500/20 p-1.5 rounded-xl">
          <AlertTriangle className="h-4 w-4 text-red-400" />
        </div>
        <div className="flex flex-col mr-4">
          <span className="text-xs text-gray-400 font-medium">{t('dashboard.page.errorOccurred')}</span>
          <span className="text-sm font-semibold">{message}</span>
        </div>
        <button onClick={onClose} className="p-2 hover:bg-white/10 rounded-xl transition-colors">
          <X className="h-4 w-4 text-gray-400" />
        </button>
      </div>
    </div>
  );
}
